import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getWeatherImage} from "../../../utils/utils";
import {CircularProgressBar} from "../../progress-bar/CircularProgressBar";
import Budgets from "../../budget/Budgets";
import TimesSpent from "../../time-spent/TimesSpent";
import SetDateModal from "../../modal/SetDateModal";
import styled, {css} from "styled-components"
import ShareWithTeam from "../../modal/ShareWithTeam";
import SubTagPlentyCard from "../../tag/subTag/SubTagPlentyCard";
import Date from "./Card/DateContainer";
import Members from "./Members";
import SuccessDifficultyThreat from "./SuccessDifficultyThreat";
import OKRsvg from '../../../images/OKR/OKR_target.svg';
import ButtonsContainer from "./ButtonsContainer";
import AxisStakeSection from "./AxisStakeSection";
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import ExitButton from "../../buttons/ExitButton";
import {CLEAR_PROJECT} from "../actionsType";
import ActionsByProjectContainer from "./ActionsByProjectContainer";
import YesNoModal from "../../modal/YesNoModal";
import UpdateProject from "../one-project/update/UpdateProject";
import {deleteOneProject, loadProject} from "../one-project/projectAction";
import {loadProjects} from "../projects/projectsAction";
import TitleSection from "../../guided-update/guided-update-project/TitleSection";

import {
    DASHBOARD_ABSOLUTE_ROUTE,
    DASHBOARD_ROUTE,
    GUIDED_UPDATE_PROJECT_ROUTE,
    HOME_ROUTE,
    PROJECTS_ABSOLUTE_ROUTE,
    PROJECTS_ROUTE,
    STRATEGY_ABSOLUTE_ROUTE,
    STRATEGY_ROUTE
} from "../../../routes/routesName";
import Loader from "../../progress-bar/Loader";
import KanbanModal from "../../modal/KanbanModal";
import LinksModal from "../../modal/LinksModal";
import Objectives from "../../objective/Objectives";
import {getDateInFrench} from "../../../utils/dateUtils";


export const ContainerCard = styled.div`
  border-radius: 15px;
`
const PitchProject = ({toggleHandler, fromGuidedUpdate}) => {
    let {projectId} = useParams();

    const dispatch = useDispatch()


    useEffect(() => {
        if (projectId) {
            dispatch(loadProject(projectId))
        }
    }, [dispatch, projectId])


    const location = useLocation()
    const navigate = useNavigate()
    const [isOpenSeeYouModal, setIsOpenSeeYouModal] = useState(false)
    const [isOpenShareWithModal, setIsOpenShareWithModal] = useState(false)
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const [isOpenUpdateProject, setIsOpenUpdateProject] = useState(false)
    const [isOpenKanban, setIsOpenKanban] = useState(false)
    const [isOpenLinkModal, setIsOpenLinkModal] = useState(false)
    const {isBudgetOptional, isTimeSpentOptional} = useSelector(state => state.project)

    const deleteProject = async (project_id) => {
        await dispatch(deleteOneProject(project_id))
        await dispatch(loadProjects(currentUser.id))
        navigate.push('/')
    }

    useEffect(() => {
        return () => {
            if (!location.pathname.includes(GUIDED_UPDATE_PROJECT_ROUTE))
                dispatch({type: CLEAR_PROJECT})
        }
    }, [dispatch, location.pathname])

    /*
    * useEffect(() => {
        if(location.pathname.startsWith(GUIDED_UPDATE_PROJECT_ROUTE)){
            setIsOpenShareWithModal(true)
        }
    },[location.pathname])
    * */

    const displayModal = () => {
        if (isDeleteModalOpen) {
            return (
                <YesNoModal
                    name={"ce projet (archivé pendant 30 jours avant suppression)"}
                    setOpenModal={setIsDeleteModalOpen}
                    id={id}
                    handleClickYesAction={deleteProject}
                />
            )
        } else if (isOpenUpdateProject) {
            return (
                <UpdateProject
                    setIsOpenUpdateProject={setIsOpenUpdateProject}/>
            )
        } else if (isOpenSeeYouModal) {
            return (
                <SetDateModal
                    title={"Choisir une date pour la prochaine mise-à-jour guidée"}
                    action={"SeeYouForGuidedUpdate"}
                    id={id}
                    setOpenModal={setIsOpenSeeYouModal}
                />
            )
        } else if (isOpenShareWithModal) {
            return (
                <ShareWithTeam
                    setIsOpenShareWithModal={setIsOpenShareWithModal}
                    label={'le pitch projet'}
                    name={'project'}
                />
            )
        } else if (isOpenKanban) {
            return <KanbanModal setOpen={setIsOpenKanban}/>
        } else if (isOpenLinkModal) {
            return <LinksModal setIsOpen={setIsOpenLinkModal}/>
        }
    }


    const {
        id,
        name,
        referenceCode,
        comment,
        success,
        difficulties,
        weather,
        objectives,
        tags,
        startDate,
        endDate,
        lastUpdate,
        advancement,
        threatCreated,
        threatNotCreated,
        realTimeSpent,
        estimatedTimeSpent,
        isLoading,
        actionAdvancementAVG,
        nextReview
    } = useSelector((state) => state.project);

    const currentUser = useSelector(state => state.currentUser)
    const nextReviewFR = nextReview? getDateInFrench(nextReview) : ""


    const choicesArea = [
        {
            id: 1,
            name: "success",
            value: success,
        }, {
            id: 2,
            name: "difficulties",
            value: difficulties,
        },
        {
            id: 3,
            name: "threatCreated",
            value: threatCreated,
        },
        {
            id: 4,
            name: "threatNotCreated",
            value: threatNotCreated,
        },
    ]

    const close = () => {
        const BASE_PATHNAME = location.pathname.split("/")[1]
        if (BASE_PATHNAME === PROJECTS_ROUTE) {
            navigate(HOME_ROUTE)
        }
        if (BASE_PATHNAME === STRATEGY_ROUTE) {
            navigate(STRATEGY_ABSOLUTE_ROUTE)
        }
        if (BASE_PATHNAME === DASHBOARD_ROUTE) {
            navigate(DASHBOARD_ABSOLUTE_ROUTE)
        }
        else {
            navigate(HOME_ROUTE)
        }
    }

    const displayFirstSectionAccordingToPath = () => {
        const pathname = location.pathname
        if (pathname.startsWith(GUIDED_UPDATE_PROJECT_ROUTE)) {
            return (
                <>
                    {!fromGuidedUpdate &&
                        <FirstSectionButton>
                            <ExitButton
                                closeUpdate={close}
                            />
                        </FirstSectionButton>
                    }
                    <TitleSection
                        toggleHandler={toggleHandler}
                        title={"Félicitations !"}
                        isMax={true}
                    />
                    <FirstSection>
                        <h3> Vous avez mis à jour votre Pitch projet </h3>
                    </FirstSection>
                </>
            )
        }
        if (pathname.startsWith(PROJECTS_ABSOLUTE_ROUTE) || pathname.includes(STRATEGY_ABSOLUTE_ROUTE) || pathname.includes(DASHBOARD_ROUTE)) {
            return (
                <FirstSectionButton>
                    <ExitButton
                        closeUpdate={close}
                    />
                </FirstSectionButton>
            )
        }
    }

    return (
        <div
            className={fromGuidedUpdate ? null : "shadow"}>
            <Container $mode={fromGuidedUpdate}>
                {isLoading ?
                    <Loader/>
                    :
                    <>
                        {displayFirstSectionAccordingToPath()}
                        <TitleProject>
                            <h1> {name}  </h1>
                            <h5> (ref : {referenceCode? referenceCode : "non référencé"})  </h5>
                        </TitleProject>
                        <h5>Prochaine revue de projet : {nextReview ? nextReviewFR : "à déterminer"}</h5>
                        <AxisStakeSection/>
                        <TagsContainer>
                            {tags.map(tag => (
                                <SubTagPlentyCard
                                    color={tag.color}
                                    id={tag.id}
                                    category={tag.category}
                                    name={tag.name}
                                    key={tag.id}
                                    className={"no-hover"}
                                />
                            ))}
                        </TagsContainer>


                        <Date
                            startDate={startDate}
                            endDate={endDate}
                            lastUpdate={lastUpdate}
                        />
                        <Grid>
                            <CommentSection className={"white-container"}>
                                <h2> Commentaires : </h2>
                                <p>{comment ? comment : "Il n'y a pas de commentaire pour ce projet"}</p>
                            </CommentSection>
                            <IndicatorsContainer className={"white-container"}>
                                <div className={"weather-indicator"}>
                                    <img src={getWeatherImage(weather)} alt={"météo"}/>
                                    <p className={"fw-700"}>Météo</p>
                                </div>
                                <div className={"container-advancement-project"}>
                                    {CircularProgressBar(advancement)}
                                    <p className={"fw-700"}>Projet</p>
                                </div>
                                <div className={"container-advancement-project"}>
                                    {CircularProgressBar(actionAdvancementAVG)}
                                    <p className={"fw-700"}>Actions</p>
                                </div>
                            </IndicatorsContainer>

                            <ButtonsContainer
                                setIsOpenShareWithModal={setIsOpenShareWithModal}
                                setIsOpenSeeYouModal={setIsOpenSeeYouModal}
                                setIsOpenKanban={setIsOpenKanban}
                                setIsOpenLinkModal={setIsOpenLinkModal}
                            />

                            <Members/>
                            <BudgetContainer style={{ gridRow: isBudgetOptional && "span 1"  }}>
                                <Budgets
                                    openEditBudgetModal={true}
                                />
                            </BudgetContainer>
                            <TimeSpentContainer style={{ gridRow: isTimeSpentOptional && "span 1"  }}>
                                <TimesSpent
                                    estimatedTimeSpent={estimatedTimeSpent}
                                    realTimeSpent={realTimeSpent}
                                    openEditTimeSpentModal={true}
                                />
                            </TimeSpentContainer>

                            <SuccessDifficultyContainer>
                                {choicesArea.map(c => (
                                    <SuccessDifficultyThreat
                                        value={c.value}
                                        name={c.name}
                                        key={c.id}
                                    />
                                ))}
                            </SuccessDifficultyContainer>
                            <Div>
                                <ContainerOKR>
                                    <div className={"flex-row"}>
                                        <img className="pad-0-05" src={OKRsvg} alt='Objectives'/>
                                        <h2> Objectifs / Résultats clés </h2>
                                    </div>
                                    {objectives.length > 0 ?
                                        <Objectives
                                            objectives={objectives}
                                            isInteractive={false}
                                            projectId={id}
                                            inPitchProject={true}
                                            inObjectivePage={false}
                                        /> :
                                        "Aucun objectifs pour ce projet"
                                    }
                                </ContainerOKR>
                                <ActionsByProjectContainer/>
                            </Div>
                        </Grid>
                    </>
                }
                {displayModal()}
            </Container>
        </div>
    )
}


const TitleProject = styled.div`
  display: flex;
  flex-direction: row;
  width: 80%;
  gap: 1.5rem;
  
  h5{
    padding-top: 15px;
    width: 20%;
    font-size: small;
  }
  h1{
    width: 80%;

  }
`

const BudgetContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column-start: 2;
  grid-column-end: 12;
  grid-row: span 4;
`
const TimeSpentContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column-start: 2;
  grid-column-end: 12;
  grid-row: span 2;
`
const FirstSectionButton = styled.div`
  display: ${props => props.primary ? "grid" : "flex"};
  grid-template-columns: repeat(12, 1fr);
  width: 100%;
  flex-direction: ${props => props.primary ? "row" : "row-reverse"};
  justify-content: space-between;

  .go-home-btn {
    grid-column-start: 10;
    grid-column-end: 13;
  }

  .prev-btn {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  @media (min-width: 1200px) {
    padding-right: 2em;
  }
`
const FirstSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  h3 + h1 {
    line-height: 4em;
  }
`


const Container = styled.div`
  display: flex;
  padding: 2em;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  gap: 2em;

  .white-container {
    background-color: var(--color-white);
    display: flex;
    border-radius: 15px;
    padding: 1rem;
    align-items: center;
    justify-content: center;
  }

  .div-first-child {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .edit-btn-full-txt {
    margin-right: 1rem;
  }

  h1 {
    text-align: center;
  }

  .axis-stakes-section {
    width: 80%;
  }
    ${(props) => {
        switch (props.$mode) {
            case true:
                return css`
                    min-height: 100%;
                    width: 100%;
                `;
            default:
                return css`
                    background-color: var(--color-pale-blue);
                    justify-content: space-between;
                    box-shadow: 1px 1px 5px rgba(33, 37, 41, 1);
                    border-radius: 15px;
                    min-height: 100vh;
                    width: 100vw;
                    @media (min-width: 768px) {
                        position: fixed;
                        margin: auto;
                        inset: 0;
                        min-height: unset;
                        width: calc(100% - 100px);
                    }
                    @media (min-width: 1224px) {
                        width: 1200px;
                        min-width: 1200px;
                        max-width: 1500px;
                        left: 0;
                        right: 0;
                        margin-left: auto;
                        margin-right: auto;
                    }
                `;
        }
    }};
`
const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 1224px) {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(20, 6rem);
    width: 100%;
    gap: 1rem;
  }

`
const CommentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  grid-column-start: 2;
  grid-column-end: 12;
  grid-row-start: 1;
  grid-row-end: 2;

`

const IndicatorsContainer = styled.div`
  display: flex;
  gap: 2em;
  justify-content: center;

  img {
    width: 6rem;
    height: auto;
    flex-grow: 1;
  }

  .weather-indicator {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: center;
  }

  .container-advancement-project {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: space-around;

    #circular-progress-bar {
      height: 100%;
      justify-content: center;
      align-items: center;
    }
  }

  /*  grid-column-start: 2;
    grid-column-end: 12;
    grid-row-start: 1;
    grid-row-end: 3;*/
  @media (min-width: 1224px) {
    grid-column-start: 2;
    grid-column-end: 8;
    grid-row-start: 2;
    grid-row-end: 4;
    .container-advancement-project {
      #circular-progress-bar div svg {
        width: 6rem;
      }

      #circular-progress-bar div h4 {
        bottom: 3em;
      }
    }
  }
`


const Div = styled.div`
  display: flex;
  flex-direction: column;
  grid-column-start: 2;
  grid-column-end: 12;
  grid-row: span 2;
  gap: 1em;
  margin-bottom: 2em;
  background-color: var(color--white);
`
const SuccessDifficultyContainer = styled(ContainerCard)`
  background-color: var(--color-white);
  display: grid;
  gap: 1em;
  padding: 2em;

  img {
    height: 30px;
  }

  @media (min-width: 900px) {
    grid-column-start: 2;
    grid-column-end: 12;
    grid-row: span 5;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    width: 100%;
    gap: 2em;
    label {
      text-align: center;
    }
  }
`

const ContainerOKR = styled(ContainerCard)`
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
  padding: 1em 0;
  grid-row: auto;

  .okr-card {
    grid-template-columns: 20% 30% 30% 15%;
  }
`

const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 80%;
  justify-content: center;
`

export default PitchProject;